import { ArrowRight, Loader2 } from 'lucide-react';

interface OnboardingFooterProps {
  onSubmit?: () => void;
  onSkip?: () => void;
  skipLabel?: string;
  loading?: boolean;
  disabled?: boolean;
  submitLabel?: string;
  type?: 'button' | 'submit';
}

export function OnboardingFooter({
  onSubmit,
  onSkip,
  skipLabel = 'Skip for now',
  loading = false,
  disabled = false,
  submitLabel = 'Continue',
  type = 'submit',
}: OnboardingFooterProps) {
  return (
    <div
      className="flex items-center justify-between"
      style={{
        padding: '24px 0 0',
        borderTop: '1px solid rgba(255,255,255,0.06)',
        marginTop: 28,
      }}
    >
      <div>
        {onSkip && (
          <button
            type="button"
            onClick={onSkip}
            className="transition-colors"
            style={{
              fontSize: 12,
              color: 'rgba(255,255,255,0.3)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
            }}
            onMouseEnter={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.5)')}
            onMouseLeave={e => (e.currentTarget.style.color = 'rgba(255,255,255,0.3)')}
          >
            {skipLabel}
          </button>
        )}
      </div>

      <button
        type={type}
        onClick={onSubmit}
        disabled={loading || disabled}
        className="flex items-center gap-2 transition-opacity"
        style={{
          background: disabled ? 'rgba(255,255,255,0.06)' : '#C2541A',
          color: disabled ? 'rgba(255,255,255,0.3)' : '#fff',
          borderRadius: 6,
          padding: '9px 20px',
          fontSize: 13,
          fontWeight: 500,
          border: 'none',
          cursor: disabled || loading ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
        }}
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            Saving...
          </>
        ) : (
          <>
            {submitLabel}
            <ArrowRight className="w-4 h-4" />
          </>
        )}
      </button>
    </div>
  );
}
